import React, { useState, useEffect } from "react";
import Toggle from "react-toggle";
import numeral from "numeral";

import { LineInput } from "components/Inputs/LineInput";

import styles from "../style.module.css";

const ContinuousAssumptionsCard = (props) => {
  const {
    isRealityHammer,
    runId,
    updateIsRealityHammer,
    optimized,
    setup,
    updateExpectedCountContinuous,
    updateExpectedValueContinuous,
    isOverallSegment
  } = props;

  const baselineCount =
    optimized && isOverallSegment ? optimized.overallExpectedContinuousCount : optimized.continuousCount;
  const baselineAverage =
    optimized && isOverallSegment ? optimized.overallExpectedContinuousValue : optimized.continuousValue;

  const jobId = optimized && optimized.innerSegment && optimized.innerSegment.job && optimized.innerSegment.job.job_id;

  const [inputtedContinuousCount, setInputtedContinuousCount] = useState(baselineCount);
  const [inputtedContinuousAverage, setInputtedContinuousAverage] = useState(baselineAverage);

  useEffect(() => {
    //check if reality hammer & if custom exists else put in baseline

    isRealityHammer && optimized && optimized.setup && optimized.setup.expectedCountContinuous
      ? setInputtedContinuousCount(optimized.setup.expectedCountContinuous)
      : setInputtedContinuousCount(baselineCount);

    isRealityHammer && optimized && optimized.setup && optimized.setup.expectedValueContinuous
      ? setInputtedContinuousAverage(optimized.setup.expectedValueContinuous)
      : setInputtedContinuousAverage(baselineAverage);
  }, [jobId, isRealityHammer, setup]);

  useEffect(() => {
    //for if you change to overall and it knows to sum the total
    //it needs to check if there was custom values
    if (isOverallSegment) {
      const overallCount =
        optimized && optimized.overallExpectedContinuousCount
          ? optimized.overallExpectedContinuousCount
          : optimized.overallContinuousCount;

      const overallAverage =
        optimized && optimized.overallExpectedContinuousValue
          ? optimized.overallExpectedContinuousValue
          : optimized.overallContinuousValue;
      overallCount !== inputtedContinuousCount && setInputtedContinuousCount(overallCount);
      overallAverage !== inputtedContinuousAverage && setInputtedContinuousAverage(overallAverage);
    }
  }, [isOverallSegment, optimized]);

  const onCountChange = (value, update = false) => {
    setInputtedContinuousCount(value);
    update && jobId && isRealityHammer && !isOverallSegment && updateExpectedCountContinuous(jobId, value);
  };

  const onAverageChange = (value, update = false) => {
    setInputtedContinuousAverage(value);
    update && jobId && isRealityHammer && !isOverallSegment && updateExpectedValueContinuous(jobId, value);
  };

  const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

  const numberPredicted = setup.numberPredicted ? setup.numberPredicted : "Price";

  const hasLinkedProject = false;

  return (
    <div className={styles.eBotBox}>
      {!isOverallSegment && optimized ? (
        <div
          className={styles.aHeader}
          style={{
            borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
            padding: "20px"
          }}
        >
          <div
            style={{
              width: "calc(100% - 75px"
            }}
          >
            {`Will future ${transactionLabel} and average ${numberPredicted} match the baseline behavior assumptions?`}
          </div>
          <div style={{ width: "100px" }}>
            <div id={"eToggle"} className={styles.tHolder}>
              <Toggle
                checked={isRealityHammer === true}
                icons={false}
                onChange={(e) => updateIsRealityHammer(runId, !isRealityHammer)}
                disabled={isRealityHammer && hasLinkedProject}
              />
              <span className={isRealityHammer === true ? styles.yPos : styles.nPos}>
                {isRealityHammer !== true ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      ) : null}
      <div className={styles.wQuestion}>
        <div className={styles.rHammer}>
          <div className={styles.aHeader}>
            <div style={{ width: "34%" }}>{"Measure"}</div>
            <div style={{ width: "33%" }}>{"Baseline"}</div>
            <div style={{ width: "33%" }}>{"Expected"}</div>
          </div>
          <div className={styles.assumptionEditItem}>
            <div className={styles.costEditThirdsOne} style={{ width: "34%" }}>
              Count
            </div>
            <div className={styles.costEditThirdsOne} style={{ width: "33%" }}>
              {baselineCount ? numeral(baselineCount).format("0a") : 0}
            </div>
            <div className={styles.costEditThirdsOne} style={{ width: "33%" }}>
              <LineInput
                key={optimized && optimized.innerSegment ? optimized.innerSegment.id : "none"}
                isMediumBox
                isDisabled={isRealityHammer !== true}
                style={{ color: "#4B495B" }}
                value={inputtedContinuousCount}
                onChange={(val) => {
                  !isNaN(val) && onCountChange(val, true);
                }}
              />
            </div>
          </div>
          <div className={styles.assumptionEditItem}>
            <div className={styles.costEditThirdsOne} style={{ width: "34%" }}>
              Average
            </div>
            <div className={styles.costEditThirdsOne} style={{ width: "33%" }}>
              {baselineAverage ? numeral(baselineAverage).format("0.0a") : 0}
            </div>
            <div className={styles.costEditThirdsOne} style={{ width: "33%" }}>
              <LineInput
                isMediumBox
                isDisabled={isRealityHammer !== true}
                style={{ color: "#4B495B" }}
                value={inputtedContinuousAverage}
                onChange={(val) => {
                  !isNaN(val) && onAverageChange(val, true);
                }}
              />
            </div>
          </div>
          {isOverallSegment ? (
            <div
              style={{
                marginTop: "20px"
              }}
            >
              {"Select a subgroup to update expected behavior"}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ContinuousAssumptionsCard;
